import axios from "axios";
import { ReportSummary } from "../types/reports/report";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/dmservices/api/v1'; // Default to your local API if not set
console.log("API Base URL:", API_BASE_URL);

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false, 
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
  },
});


export const fetchReportSummary = async (
  month: string
): Promise<ReportSummary> => {
  const res = await axios.get<ReportSummary>( `${API_BASE_URL}/reports/monthly-leads`, { params: { month } }  );
/*
   const response  = await apiClient.get<ReportSummary>(
    `${API_BASE_URL}/reports/monthly-leads`,
    { params: { month } }
  );
*/
  return res.data;
};
